import React from 'react';
import { Card } from '@repo/ui/Card';
import { Item, ItemDescription, ItemTitle } from '@repo/ui/Item';

import { Mercury } from '@repo/types/Models';
interface AccountPlanProps {
  account: Mercury.Models.Account;
}

const AccountPlan = ({ account }: AccountPlanProps) => {

  return (
    <Card title={`Account Overview`}>
      <div className="grid grid-cols-2 gap-4">
        <Item className="flex-col items-start border-0">
          <ItemTitle>Account Plan</ItemTitle>
          <ItemDescription className="text-2xl font-bold">
            {account?.servicePlan?.name}
          </ItemDescription>
        </Item>
        <Item className="flex-col items-start border-0">
          <ItemTitle>Support Plan</ItemTitle>
          <ItemDescription className="text-2xl font-bold">
            {account?.supportPlan?.name}
          </ItemDescription>
        </Item>
      </div>
    </Card>
  );
};

export default AccountPlan;
